import React from "react";
import { useLocation } from "react-router-dom";
import Customizer from "../components/Customizer";
import PromoStrip from "../components/PromoStrip";
import ProductGrid from "../components/ProductGrid";

export default function Personalizar() {
  const loc = useLocation();
  const product = loc.state?.product || null;

  return (
    <>
      <PromoStrip />
      <Customizer initialProduct={product} />
      <ProductGrid
        defaultCategory="fundas_personalizadas"
        hideFilters
        title="Otras opciones personalizables"
        subtitle="Más bases para tu funda única."
      />
    </>
  );
}
